import React from 'react';
import {
  ButtonContainer,
  ButtonIcon,
  ButtonIconColored,
  ButtonText,
} from './style';

function StyledButton({ URL, Text, Icon, onAccept, ColoredIcon }) {
  const pendingRef = React.useRef(false);
  const redircetFun = async (url) => {
    if (pendingRef.current) return;
    pendingRef.current = true;
    if (onAccept) {
      // Wait for the accept call to commit before navigating: the review page
      // fetches the submission on load, and racing the accept leaves the
      // reviewer on a stale read-only view until a manual reload.
      try {
        await onAccept();
      } catch (e) {
        // Still navigate — the page renders whatever state the request left
        // behind (e.g. already accepted by another reviewer).
      }
    }
    window.location.href = url;
    pendingRef.current = false;
  };
  return (
    <>
      <ButtonContainer onClick={() => redircetFun(URL)}>
        <ButtonText>{Text}</ButtonText>
        <ButtonIcon src={Icon} />
        {ColoredIcon ? <ButtonIconColored src={ColoredIcon} /> : <></>}
      </ButtonContainer>
    </>
  );
}

export default StyledButton;
